<template>
  <div class="pageSearchReservation">
    <h2>{{ $t("pages.wording.searchReserve") }}</h2>
    <!--預約單查詢-->
    <el-form label-width="150px">
      <h3>{{ $t("pages.wording.searchCondition") }}</h3>
      <!--查詢條件-->
      <div class="boxContain c-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveArea')"
              ><!--抵達廠區-->
              <el-select
                v-model="queryItems.reserveArea"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
                @change="selectedArea"
              >
                <el-option v-for="item in base.areaBase" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.enterReason')" prop="enterReason"
              ><!--入廠事由-->
              <el-select
                v-model="queryItems.enterReason"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option
                  v-for="item in enterReasonBase"
                  :label="item[$i18n.locale]"
                  :value="item.code"
                  :key="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
              ><!--抵達廠別-->
              <el-select
                v-model="queryItems.reserveFactory"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option v-for="item in base.factoryBase" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveStatus')" prop="reserveStatus"
              ><!--狀態-->
              <el-select
                v-model="queryItems.reserveStatus"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option :label="$t('reserve.status.cancel')" value="cancel"></el-option
                ><!--取消-->
                <el-option :label="$t('reserve.status.temporary')" value="temporary"></el-option
                ><!--暫存-->
                <el-option :label="$t('reserve.status.vendorComfirm')" value="vendorComfirm"></el-option
                ><!--待廠商確認-->
                <el-option :label="$t('reserve.status.entering')" value="entering"></el-option
                ><!--待進廠檢查-->
                <el-option :label="$t('reserve.status.in1')" value="in1"></el-option
                ><!--待出廠初檢-->
                <el-option :label="$t('reserve.status.in2')" value="in2"></el-option
                ><!--待出廠複檢-->
                <el-option :label="$t('reserve.status.finished')" value="finished"></el-option
                ><!--已完成-->
                <el-option :label="$t('reserve.status.enteringFail')" value="enteringFail"></el-option
                ><!--進廠檢查不合格-->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveDate"
              ><!--預約進廠日期-->
              <el-date-picker
                v-model="queryItems.reserveArriveTime"
                type="daterange"
                range-separator="-"
                clearable
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.applyDate')" prop="createTime"
              ><!--申請時間-->
              <el-date-picker
                v-model="queryItems.applyDatetime"
                type="daterange"
                clearable
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveNo')"
              ><!--單號-->
              <el-input
                v-model="queryItems.reserveNo"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--boxContain c-form-->
      <div class="buttons c-form">
        <el-button class="blue-button button-right" @click="sentApply(1)" type="primary">{{
          $t("pages.button.search")
        }}</el-button
        ><!--查詢-->
        <el-button v-if="back" class="button-right" @click="cleanSearchVal" type="warning" style="margin-right: 10px">{{
          $t("pages.button.clean")
        }}</el-button
        ><!--清除-->
        <el-button
          class="blue-button button-right"
          @click="exportExcel"
          :disabled="exportExcelISLoading"
          :icon="exportExcelISLoading ? 'el-icon-loading' : ''"
          type="primary"
          style="margin-right: 10px"
          >{{ $t("pages.button.exportReserveData") }}</el-button
        >
      </div>
    </el-form>

    <h3>{{ $t("pages.wording.searchResult") }}</h3>
    <!--查詢結果-->
    <div class="boxContain c-table">
      <el-tabs v-model="activeName">
        <el-tab-pane label="preProcess" name="first">
          <span slot="label"><i class="el-icon-search"></i>{{ $t("pages.wording.searchResult") }}</span
          ><!--查詢結果-->
          <div class="s-table">
            <template>
              <el-table
                v-loading="tableIsLoading"
                :data="reserveTable"
                highlight-current-row
                @current-change="applyPageCheck"
                border
                style="width: 100%"
                height="450px"
              >
                <el-table-column label="Action" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.reserveStatus == 'vendorComfirm'" type="text" size="medium">
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button v-else type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="100"> </el-table-column
                ><!--OACode-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130"> </el-table-column
                ><!--單號-->
                <el-table-column
                  prop="releaseOrder"
                  :label="$t('pages.wording.releaseOrder')"
                  align="center"
                  width="120"
                >
                  <template
                    slot-scope="scope"
                    v-if="scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE'"
                  >
                    <span class="releaseBtn" @click.stop="openReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="driverName" :label="$t('pages.wording.driverName')" width="110"
                  ><!--駕駛員姓名-->
                  <template slot-scope="scope">
                    {{ !scope.row.tempCar ? scope.row.driverName : scope.row.tmpDriverName }}
                  </template>
                </el-table-column>
                <el-table-column prop="driverID" :label="$t('pages.wording.driverID')" width="90"
                  ><!--駕駛證號-->
                  <template slot-scope="scope">
                    {{ !scope.row.tempCar ? scope.row.driverID : scope.row.tmpDriverID }}
                  </template>
                </el-table-column>
                <el-table-column prop="carPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    {{ !scope.row.tempCar ? scope.row.carPlat : scope.row.tmpCarPlat }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveArriveDate" :label="$t('pages.wording.reserveArriveDate')" width="170"
                  ><!--預約進廠日期-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="enteringDatetime" :label="$t('pages.wording.enteringTime')" width="170"
                  ><!--實際進廠時間-->
                  <template slot-scope="scope">
                    {{
                      scope.row.enteringDatetime != null
                        ? formateDatetimeStr("DateTime", scope.row.enteringDatetime)
                        : "NA"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="leaveDatetime" :label="$t('pages.wording.leaveDate')" width="170"
                  ><!--實際離廠時間-->
                  <template slot-scope="scope">
                    {{
                      scope.row.leaveDatetime != null ? formateDatetimeStr("DateTime", scope.row.leaveDatetime) : "NA"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="stayTime" :label="$t('pages.wording.stayTime')" width="120"></el-table-column
                ><!--停車時間-->
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.reserveFactory')" width="120">
                </el-table-column
                ><!--抵達廠區-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="140">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠是由-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達接洽人-->
                <el-table-column prop="reserveStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column prop="applyDate" :label="$t('pages.wording.applyDate')" width="130">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.reserveTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="reserveTableTotalCount"
              @current-change="changePageReserveTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="$t('pages.wording.releaseOrder')" :visible.sync="dialog.showreleaseOrder" width="50%">
      <el-table
        class="dialogReleaseOrder"
        :data="dialog.releasTableData"
        border
        style="width: 90%"
        height="300px"
        @current-change="goReleaseInfoPage"
        :default-sort="{ prop: 'saleDate', order: 'descending' }"
      >
        <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseNo')"> </el-table-column>
        <el-table-column prop="SO" label="SO No." width="120"> </el-table-column>
        <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="120"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.showreleaseOrder = false">{{ $t("pages.button.close") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { store } from "@/store/store"
import { utils } from "@/utils/utils.js"
import { api } from "@/utils/api.js"
export default {
  name: "NewPageSearchReservation",
  props: ["back"],
  data() {
    return {
      activeName: "first",
      queryItems: {
        reserveRegion: "",
        reserveArea: "",
        reserveFactory: "",
        vendor: "",
        deltaContactName: "",
        enterReason: "",
        applyDatetime: null,
        applyDatetimeStart: "",
        applyDatetimeEnd: "",
        reserveArriveTime: null,
        reserveArriveTimeStart: "",
        reserveArriveTimeEnd: "",
        reserveStatus: "",
        reserveNo: "",
      },
      dialog: {
        showreleaseOrder: false,
        releasTableData: [],
        tableIsLoading: false,
      },
      tableIsLoading: false,
      reserveTable: [],
      reserveTableTotalCount: 0,
      reserveNewTable: [],
      currentRow: null,
      pages: {
        pageCount: this.$global.pageCount,
        pageSize: this.$global.pageSize,
        reserveTablePage: {
          pageCurrent: 1,
        },
      },
      base: {
        areaBase: [],
        factoryBase: [],
      },
      exportExcelISLoading: false,
      enterReasonBase: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserLoginData"]),
    ...mapActions(["KeepSearchVendorReserve"]),
    init() {
      if (this.$props.back) this.initSearchVal()

      this.queryTable()
      this.getFactoryList(null)
      this.getAreaList()
    },
    getAreaList() {
      this.$store.dispatch("getArea", {})
    },
    getFactoryList(area) {
      const paramter = {
        area: area === "" ? null : area,
      }
      this.$store.dispatch("getFactory", paramter)
    },
    initSearchVal() {
      this.queryItems.reserveArea = store.state.keepSearchVendorReserve.reserveArea
      this.queryItems.enterReason = store.state.keepSearchVendorReserve.enterReason
      this.queryItems.reserveFactory = store.state.keepSearchVendorReserve.reserveFactory
      this.queryItems.reserveStatus = store.state.keepSearchVendorReserve.reserveStatus
      this.queryItems.applyDatetime = store.state.keepSearchVendorReserve.applyDatetime
      this.queryItems.reserveArriveTime = store.state.keepSearchVendorReserve.reserveArriveTime
    },
    keepSearchVal() {
      const parameter = {
        reserveArea: this.queryItems.reserveArea,
        enterReason: this.queryItems.enterReason,
        reserveFactory: this.queryItems.reserveFactory,
        reserveStatus: this.queryItems.reserveStatus,
        reserveArriveTime: this.queryItems.reserveArriveTime,
        applyDatetime: this.queryItems.applyDatetime,
        active: true,
      }
      this.KeepSearchVendorReserve(parameter)
    },
    cleanSearchVal() {
      const parameter = {
        active: false,
      }
      this.KeepSearchVendorReserve(parameter)
      this.initSearchVal()
    },
    changePageReserveTable(page) {
      const parameter = this.getSearchParameters()
      this.getReserveTableData(parameter, page, this.pages.pageSize)
    },
    selectedArea(area) {
      this.getEnterReasonBase()
      this.base.factoryBase = []
      this.getFactoryList(area)
    },
    queryTable() {
      const parameter = {
        DataType: "Custom",
        QueryReserveStatus: [
          "temporary",
          "cancel",
          "vendorComfirm",
          "entering",
          "in1",
          "in2",
          "finished",
          "enteringFail",
        ],
      }
      this.getSearchResult(parameter, 1, this.pages.pageSize)
    },
    applyPageCheck(val) {
      if (val.reserveStatus == "vendorComfirm") this.applyForm(val)
      else this.applyInfo(val)
    },
    getSearchParameters() {
      const parameter = {
        reserveRegion: this.queryItems.reserveRegion,
        ReserveArea: this.queryItems.reserveArea,
        ReserveFactory: this.queryItems.reserveFactory != "" ? [this.queryItems.reserveFactory] : [],
        vendor: this.queryItems.vendor,
        EnterReason: this.queryItems.enterReason,
        ReserveNo: this.queryItems.reserveNo,
        DataType: "Custom",
        QueryReserveStatus:
          this.queryItems.reserveStatus == ""
            ? ["temporary", "cancel", "vendorComfirm", "entering", "in1", "in2", "finished", "enteringFail"]
            : [this.queryItems.reserveStatus],
      }
      if (this.queryItems.applyDatetime != null && this.queryItems.applyDatetime.length != 0) {
        parameter.ApplyDatetimeStart = utils.getISOString(this.queryItems.applyDatetime[0] + " 00:00")
        parameter.ApplyDatetimeEnd = utils.getISOString(this.queryItems.applyDatetime[1] + " 23:59")
      }
      if (this.queryItems.reserveArriveTime != null && this.queryItems.reserveArriveTime.length != 0) {
        parameter.ReserveArriveTimeStart = utils.getISOString(this.queryItems.reserveArriveTime[0] + " 00:00")
        parameter.ReserveArriveTimeEnd = utils.getISOString(this.queryItems.reserveArriveTime[1] + " 23:59")
      }
      return parameter
    },
    sentApply(pageNumber) {
      this.keepSearchVal()
      const parameter = this.getSearchParameters()
      this.getSearchResult(parameter, pageNumber, this.pages.pageSize)
    },
    async exportExcel() {
      const vueInstance = this
      const parameter = {
        reserveRegion: vueInstance.queryItems.reserveRegion,
        ReserveArea: vueInstance.queryItems.reserveArea,
        ReserveFactory: vueInstance.queryItems.reserveFactory != "" ? [vueInstance.queryItems.reserveFactory] : [],
        vendor: vueInstance.queryItems.vendor,
        EnterReason: vueInstance.queryItems.enterReason,
        ReserveNo: vueInstance.queryItems.reserveNo,
        DataType: "Custom",
        QueryReserveStatus:
          vueInstance.queryItems.reserveStatus == ""
            ? ["temporary", "cancel", "vendorComfirm", "entering", "in1", "in2", "finished", "enteringFail"]
            : [this.queryItems.reserveStatus],
      }
      if (vueInstance.queryItems.applyDatetime != null && this.queryItems.applyDatetime.length != 0) {
        parameter.ApplyDatetimeStart = utils.getISOString(this.queryItems.applyDatetime[0] + " 00:00")
        parameter.ApplyDatetimeEnd = utils.getISOString(this.queryItems.applyDatetime[1] + " 23:59")
      }
      if (vueInstance.queryItems.reserveArriveTime != null && this.queryItems.reserveArriveTime.length != 0) {
        parameter.ReserveArriveTimeStart = utils.getISOString(this.queryItems.reserveArriveTime[0] + " 00:00")
        parameter.ReserveArriveTimeEnd = utils.getISOString(this.queryItems.reserveArriveTime[1] + " 23:59")
      }
      try {
        vueInstance.exportExcelISLoading = true
        const { data } = await api.apiExportReserveTableForVendor(parameter)
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = vueInstance.$t("pages.wording.searchReserve")
        link.click()
        vueInstance.exportExcelISLoading = false
        URL.revokeObjectURL(link.href)
      } catch (error) {
        vueInstance.exportExcelISLoading = false
      }
    },
    async getSearchResult(params, pageNumber, pageSize) {
      try {
        const { data } = await api.apiGetReserveTableCountForVendorSearch(params)
        this.reserveTableTotalCount = data
        if (this.reserveTableTotalCount > 0) {
          this.getReserveTableData(params, pageNumber, pageSize)
          this.pages.reserveTablePage.pageCurrent = pageNumber
        } else {
          this.reserveTable = []
        }
      } catch (error) {
        console.log(`get search count of reserve table occurs error:${error}`)
        this.reserveTable = []
      }
    },
    async getReserveTableData(params, pageNumber, pageSize) {
      this.tableIsLoading = true
      try {
        params.PageNumber = pageNumber
        params.PageSize = pageSize
        const { data } = await api.apiGetReserveTableForVendor(params)
        this.reserveTable = data
        this.tableIsLoading = false
      } catch {
        this.tableIsLoading = false
      }
    },
    applyForm(val) {
      const parameter = val
      parameter.parentName = "searchReserve"
      parameter.parent = true

      this.$router.push({
        name: "PageMyReservationForm",
        params: val,
      })
    },
    applyInfo(val) {
      const parameter = val
      parameter.parentName = "searchReserve"
      parameter.parent = true
      this.$router.push({
        name: "PageMyReservationInfo",
        params: val,
      })
    },
    goReleaseInfoPage(val) {
      this.$router.push({
        name: "PageVendorReleaseOrderInfo",
        params: val,
      })
    },
    async openReleaseOrderList(row) {
      try {
        const params = {
          reserveNo: row.reserveNo,
        }
        this.dialog.showreleaseOrder = true
        this.dialog.tableIsLoading = true
        const { data } = await api.apiGetVendorReleaseTable(params)
        const releaseData = data
        if (releaseData.length === 0) {
          this.dialog.releasTableData = []
        } else {
          this.dialog.releasTableData = releaseData
        }
        this.dialog.tableIsLoading = false
      } catch {
        this.dialog.releasTableData = []
        this.dialog.tableIsLoading = false
      }
    },
    async getEnterReasonBase(val) {
      try {
        this.enterReasonBase = []
        if (val) {
          const res = await api.apiGetRegionAreaByFactory({ factory: this.queryItems.reserveFactory })
          if (res.data.region && res.data.area) {
            this.enterReasonBase = await utils.getCodeListWithCulture(res.data.region, res.data.area, "enterReason")
          }
        } else {
          this.enterReasonBase = await utils.getCodeListWithCulture(
            "ALL",
            this.queryItems.reserveArea || "ALL",
            "enterReason"
          )
        }
        //刷新選項後 不在選項內的要消除
        if (!this.enterReasonBase.some((x) => x.code == this.queryItems.enterReason)) {
          this.queryItems.enterReason = ""
        }
      } catch {}
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      let code = val.code
      let message = val.message
      let cb = val.cb
      utils.alertMessage(this, code, message, cb)
    },
    "$store.getters.areaBase": function (val) {
      this.base.areaBase = val
    },
    "$store.getters.factoryBase": function (val) {
      this.base.factoryBase = val
    },
    "queryItems.reserveFactory": function (val) {
      this.getEnterReasonBase(val)
    },
  },
}
</script>

<style></style>
